import PageContext from 'global_state/context/PageContext'
import { useContext } from 'react'
import { BiArrowBack } from 'react-icons/bi'
import { PageType } from 'types/PageI'

import SCSS from 'assets/scss/App.module.scss' 
import content from 'languages/UserHeader.json'


interface TitleProps {
    back_arrow: boolean
    back_arrow_text?: string
    title: string
    page?: PageType
}

function Title(props: TitleProps) {
    const {page, dispatchPage} = useContext(PageContext)
    let lang = page.settings.language

    
    const renderBackArrowText = () => {
        return props.back_arrow_text?.toUpperCase() || content[lang].back_arrow
    }
    const renderArrow = () => {
        if (!props.back_arrow) {
            return null
        }
        return (
            <div
                className={SCSS.arrow_back} 
                onClick={() => {dispatchPage({type: "render", payload: {page: props.page || PageType.user_profile} })}}>
                <span>{renderBackArrowText()}</span>
                <BiArrowBack/>
             </div>
        )
    }
    return (
        <div className={SCSS.title}>
            {renderArrow()}
            <h3>{props.title}</h3>
        </div>
    )
}

export default Title